import sge from "../../../../assets/images/productos/sge/SERIE SGE.png";
import qr from "../../../../assets/images/QR Fabian Llamazares.svg";
import Producto from "../../../../components/producto";
import pic1 from "../../../../assets/images/productos/sge/Mosaico - SG1.png";

import { useTranslation } from "react-i18next";

function SGE() {
  const { t } = useTranslation();

  return (
    <Producto
      fotos={[pic1]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "245", "145"],
        [t("corrienteNominal"), "A", "3.150", "3.150"],
        [t("corrienteBreveDuracion"), "kA (3sec)", "25", "25"],
        [t("corrienteDePicoSoportada"), "kA", "63", "63"],
        [t("tensionSoportadaFrecuenciaIndustrial"), "kV", "530", "315"],
        [t("tensionSoportadaImpulsoIndustrial"), "kV", "1200", "650/750"],
        [t("frecuenciaNominal"), "Hz", "50 / 60", "50 / 60"],
        [t("presionNominal"), "kg/cm2", "7", "7"]
      ]}
      datosTabla2={[
        [t("modelo"), "", "SGE 245", "SGE 145 - V"],
        [t("distanciaPolos"), "mm", "3.750", "-"],
        [t("ancho"), "mm", "-", "4.249"],
        [t("alto"), "mm", "6.730",  "5.607"],
        [t("profundidad"), "mm", "700", "700"],
      ]}
      nombreProducto={"SGE"}
      fotoProducto={sge}
      descripcionProducto={t("sge.titulo_descripcion")}
      caracteristicas={[
      ]}
      vendedor={{
        nombre: "Fabian Llamazares",
        telefono: "+54 9 11 5096-3680",
        mail: "fllamazares@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20SGE.pdf'}
    />
  );
}

export default SGE;